window.AdminInquiries = function AdminInquiries({ showNotification }) {
  const [inquiries, setInquiries] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [searchQuery, setSearchQuery] = React.useState('');
  const [typeFilter, setTypeFilter] = React.useState('All');
  const [statusFilter, setStatusFilter] = React.useState('All');
  const [selectedInquiry, setSelectedInquiry] = React.useState(null);

  const parseDetails = (detailsStr) => {
    try {
      if (detailsStr && (detailsStr.startsWith('{') || detailsStr.startsWith('['))) {
        return JSON.parse(detailsStr);
      }
    } catch (e) {}
    return null;
  };

  React.useEffect(() => {
    fetchInquiries();
  }, []);

  const fetchInquiries = async () => {
    setLoading(true);
    try {
      const res = await window.apiClient.get('inquiries.php');
      if (res.success) setInquiries(res.data || []);
    } catch (e) {
      setInquiries([
        {
          id: 1,
          type: 'quote',
          name: 'Dr. Rajesh Kumar',
          email: 'r.kumar@alstom.com',
          phone: '+91 98000 12345',
          company: 'Alstom Transport India',
          sector: 'Railways',
          subject_requirement: 'Turnkey Test Rig',
          message_details: 'Looking for dynamic fatigue test rig specifications for locomotive bogie frames according to UIC 541-5.',
          status: 'new',
          created_at: '2026-07-25 08:15:00'
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const handleViewInquiry = async (inq) => {
    setSelectedInquiry(inq);
    if (inq.status === 'new') {
      try {
        await window.apiClient.put('inquiries.php', { id: inq.id, status: 'read' });
        inq.status = 'read';
        setSelectedInquiry({ ...inq, status: 'read' });
        fetchInquiries();
      } catch(e) {}
    }
  };

  const handleUpdateStatus = async (id, status) => {
    try {
      await window.apiClient.put('inquiries.php', { id, status });
      showNotification(`Inquiry status marked as '${status}'.`);
      fetchInquiries();
      if (selectedInquiry && selectedInquiry.id === id) {
        setSelectedInquiry({ ...selectedInquiry, status });
      }
    } catch (err) {
      showNotification(err.message || 'Status update failed.', 'error');
    }
  };

  const handleDeleteInquiry = async (id, name) => {
    if (!window.confirm(`Delete inquiry from '${name}'?`)) return;
    try {
      const res = await window.apiClient.delete('inquiries.php', { id });
      if (res && res.success !== false) {
        showNotification(`Inquiry from '${name}' deleted successfully.`);
        if (selectedInquiry && selectedInquiry.id === id) setSelectedInquiry(null);
        await fetchInquiries();
      } else {
        showNotification(res.message || 'Deletion failed.', 'error');
      }
    } catch (err) {
      showNotification(err.message || 'Deletion failed.', 'error');
    }
  };

  const handleExportCSV = () => {
    window.open('/api/v1/inquiries.php?export=csv', '_blank');
  };

  const filteredInquiries = inquiries.filter((inq) => {
    const matchesType = typeFilter === 'All' || inq.type === typeFilter;
    const matchesStatus = statusFilter === 'All' || inq.status === statusFilter;
    const matchesSearch = inq.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          inq.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          (inq.company && inq.company.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesType && matchesStatus && matchesSearch;
  });

  return (
    <div className="space-y-6 animate-fadeIn">
      
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 bg-white p-6 rounded-2xl border border-slate-200 shadow-sm">
        <div>
          <h1 className="font-serif text-2xl font-bold text-slate-900">Inquiry & Quote Requests Manager</h1>
          <p className="font-sans text-xs text-slate-500">Review direct communications, quote specifications, and contact form messages.</p>
        </div>
        <button
          onClick={handleExportCSV}
          className="bg-slate-100 hover:bg-slate-200 border border-slate-300 text-slate-700 font-mono text-xs font-bold uppercase px-4 py-2.5 rounded-lg shadow-xs transition-all flex items-center gap-2 cursor-pointer"
        >
          <span className="material-symbols-outlined text-base">download</span>
          <span>Export Inquiries CSV</span>
        </button>
      </div>

      {/* Filter & Search */}
      <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="relative w-full md:w-80">
          <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-base">search</span>
          <input
            type="text"
            placeholder="Search by sender name, email, or company..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-9 pr-4 py-2 text-xs bg-slate-50 border border-slate-300 rounded-lg text-slate-900 outline-none focus:border-secondary font-mono"
          />
        </div>

        <div className="flex flex-wrap gap-2">
          <select
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
            className="px-3 py-2 bg-slate-50 border border-slate-300 rounded text-xs text-slate-800 outline-none font-mono"
          >
            <option value="All">All Types</option>
            <option value="quote">Quote Requests</option>
            <option value="contact">Contact Messages</option>
          </select>

          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="px-3 py-2 bg-slate-50 border border-slate-300 rounded text-xs text-slate-800 outline-none font-mono"
          >
            <option value="All">All Statuses</option>
            <option value="new">New</option>
            <option value="read">Read</option>
            <option value="replied">Replied</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-xs font-sans">
          <thead className="bg-slate-50 text-slate-500 font-mono text-[10px] uppercase border-b border-slate-200">
            <tr>
              <th className="p-4">TYPE</th>
              <th className="p-4">SENDER & COMPANY</th>
              <th className="p-4">SUBJECT / REQUIREMENT</th>
              <th className="p-4">DATE</th>
              <th className="p-4">STATUS</th>
              <th className="p-4 text-center">ACTIONS</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 font-mono">
            {filteredInquiries.length === 0 ? (
              <tr>
                <td colSpan="6" className="p-8 text-center text-slate-400 font-mono">No inquiries recorded matching filter.</td>
              </tr>
            ) : (
              filteredInquiries.map((inq) => (
                <tr key={inq.id} className="hover:bg-slate-50 transition-colors">
                  <td className="p-4">
                    <span className={`font-mono text-[10px] font-bold px-2 py-0.5 rounded uppercase ${
                      inq.type === 'quote' ? 'bg-orange-50 text-secondary border border-orange-200' : 'bg-blue-50 text-blue-700 border border-blue-200'
                    }`}>
                      {inq.type}
                    </span>
                  </td>
                  <td className="p-4">
                    <div className="font-bold text-slate-900 text-sm font-sans">{inq.name}</div>
                    <div className="text-slate-500 font-mono text-[11px]">{inq.email} {inq.company ? `(${inq.company})` : ''}</div>
                  </td>
                  <td className="p-4 font-mono text-slate-700">
                    <div className="flex items-center gap-1.5">
                      <span>{inq.subject_requirement || 'General'}</span>
                      {(() => {
                        const parsed = parseDetails(inq.message_details);
                        return parsed && parsed.filePath ? (
                          <span className="material-symbols-outlined text-[14px] text-orange-500 cursor-help" title="Attachment Drawing Present">attachment</span>
                        ) : null;
                      })()}
                    </div>
                  </td>
                  <td className="p-4 font-mono text-slate-500 text-[11px]">{inq.created_at}</td>
                  <td className="p-4">
                    <span className={`font-mono text-[10px] font-bold px-2.5 py-1 rounded uppercase ${
                      inq.status === 'new' ? 'bg-emerald-50 text-emerald-700 border border-emerald-200 animate-pulse' :
                      inq.status === 'replied' ? 'bg-blue-50 text-blue-700 border border-blue-200' : 'bg-slate-100 text-slate-600 border border-slate-200'
                    }`}>
                      {inq.status}
                    </span>
                  </td>
                  <td className="p-4 text-center">
                    <div className="flex justify-center gap-2">
                      <button onClick={() => handleViewInquiry(inq)} className="p-1.5 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded border border-slate-200 cursor-pointer" title="View Details">
                        <span className="material-symbols-outlined text-sm">visibility</span>
                      </button>
                      <button onClick={() => handleUpdateStatus(inq.id, 'replied')} className="p-1.5 bg-blue-50 hover:bg-blue-100 text-blue-700 rounded border border-blue-200 cursor-pointer" title="Mark Replied">
                        <span className="material-symbols-outlined text-sm">reply</span>
                      </button>
                      <button onClick={() => handleDeleteInquiry(inq.id, inq.name)} className="p-1.5 bg-red-50 hover:bg-red-100 text-red-600 rounded border border-red-200 cursor-pointer" title="Delete Inquiry">
                        <span className="material-symbols-outlined text-sm">delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        </div>
      </div>

      {/* Inquiry Detail Modal */}
      {selectedInquiry && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm animate-fadeIn">
          <div className="bg-white rounded-2xl border border-slate-200 shadow-2xl max-w-2xl w-full p-6 space-y-6 overflow-hidden text-slate-800">
            <div className="flex justify-between items-center border-b border-slate-100 pb-4">
              <div>
                <span className="font-mono text-xs font-bold text-secondary uppercase">{selectedInquiry.type} INQUIRY</span>
                <h3 className="font-serif text-2xl font-bold text-slate-900">{selectedInquiry.name}</h3>
              </div>
              <button onClick={() => setSelectedInquiry(null)} className="text-slate-400 hover:text-slate-800 p-1 cursor-pointer">
                <span className="material-symbols-outlined">close</span>
              </button>
            </div>

            <div className="space-y-4 text-xs font-sans">
              <div className="grid grid-cols-2 gap-4 bg-slate-50 p-4 rounded-xl border border-slate-200 font-mono">
                <div>
                  <span className="text-slate-500 block text-[10px]">EMAIL ADDRESS:</span>
                  <span className="text-slate-900 font-bold">{selectedInquiry.email}</span>
                </div>
                <div>
                  <span className="text-slate-500 block text-[10px]">PHONE / MOBILE:</span>
                  <span className="text-slate-900 font-bold">{selectedInquiry.phone || 'N/A'}</span>
                </div>
                <div>
                  <span className="text-slate-500 block text-[10px]">ORGANIZATION:</span>
                  <span className="text-slate-900 font-bold">{selectedInquiry.company || 'Individual'}</span>
                </div>
                <div>
                  <span className="text-slate-500 block text-[10px]">SECTOR:</span>
                  <span className="text-secondary font-bold">{selectedInquiry.sector || 'General'}</span>
                </div>
              </div>

              {(() => {
                const parsed = parseDetails(selectedInquiry.message_details);
                if (parsed) {
                  return (
                    <div className="space-y-4">
                      <div className="grid grid-cols-2 gap-4 bg-slate-50/50 p-4 rounded-xl border border-slate-200 font-sans text-xs">
                        <div>
                          <span className="text-slate-500 block text-[10px] font-mono">COMPONENT NAME:</span>
                          <span className="text-slate-900 font-bold">{parsed.componentName || 'N/A'}</span>
                        </div>
                        <div>
                          <span className="text-slate-500 block text-[10px] font-mono">TESTING PARAMETERS:</span>
                          <span className="text-slate-900 font-bold">{parsed.testParameters || 'N/A'}</span>
                        </div>
                        <div>
                          <span className="text-slate-500 block text-[10px] font-mono">AUTOMATION LEVEL:</span>
                          <span className="text-slate-900 font-bold">{parsed.automationLevel || 'N/A'}</span>
                        </div>
                        <div>
                          <span className="text-slate-500 block text-[10px] font-mono">TIMELINE:</span>
                          <span className="text-slate-900 font-bold">{parsed.timeline || 'N/A'}</span>
                        </div>
                      </div>

                      {parsed.filePath && (
                        <div className="bg-slate-50 p-4 rounded-xl border border-slate-200 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                          <div>
                            <span className="text-slate-500 block text-[10px] font-mono">UPLOADED RFQ DOCUMENT:</span>
                            <span className="text-slate-900 font-bold text-xs break-all">{parsed.filePath.split('/').pop()}</span>
                          </div>
                          <a
                            href={window.resolveMediaUrl ? window.resolveMediaUrl(parsed.filePath) : parsed.filePath}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-orange-50 hover:bg-orange-100 text-secondary border border-orange-200 text-[11px] font-bold px-3 py-1.5 rounded-lg flex items-center gap-1.5 transition-all shadow-xs cursor-pointer inline-flex whitespace-nowrap"
                          >
                            <span className="material-symbols-outlined text-sm">download</span>
                            <span>View Attachment</span>
                          </a>
                        </div>
                      )}

                      <div>
                        <span className="font-mono text-[10px] text-slate-500 uppercase block mb-1">SCOPE REQUIREMENTS & DESCRIPTION:</span>
                        <p className="p-4 bg-slate-50 rounded-xl border border-slate-200 text-slate-800 leading-relaxed font-sans whitespace-pre-wrap">
                          {parsed.message || 'No additional details specified.'}
                        </p>
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <div>
                      <span className="font-mono text-[10px] text-slate-500 uppercase block mb-1">INQUIRY MESSAGE & SPECIFICATIONS:</span>
                      <p className="p-4 bg-slate-50 rounded-xl border border-slate-200 text-slate-800 leading-relaxed font-sans whitespace-pre-wrap">
                        {selectedInquiry.message_details}
                      </p>
                    </div>
                  );
                }
              })()}

              <div className="pt-2 flex flex-wrap gap-2 justify-between items-center border-t border-slate-100">
                <div className="flex gap-2">
                  <button
                    onClick={() => handleUpdateStatus(selectedInquiry.id, 'replied')}
                    className="bg-secondary hover:bg-orange-600 text-white font-mono text-xs font-bold px-4 py-2 rounded shadow cursor-pointer"
                  >
                    Mark as Replied
                  </button>
                  <button
                    onClick={() => handleDeleteInquiry(selectedInquiry.id, selectedInquiry.name)}
                    className="bg-red-50 hover:bg-red-100 text-red-600 border border-red-200 font-mono text-xs font-bold px-4 py-2 rounded shadow flex items-center gap-1 cursor-pointer"
                  >
                    <span className="material-symbols-outlined text-sm">delete</span>
                    <span>Delete</span>
                  </button>
                </div>
                <button onClick={() => setSelectedInquiry(null)} className="px-4 py-2 bg-slate-100 hover:bg-slate-200 border border-slate-300 text-slate-700 font-mono text-xs rounded cursor-pointer">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};
